module.exports = __webpack_public_path__ + "img/guest-active.facf3af4.png";